import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import CreateCampaignComponent from "../../../Components/CampaginComponent/CreateCampaignComponent";

function CreateCampaign() {
  let navigate = useNavigate();
  let params = useParams();

  return (
    <div>
      <CreateCampaignComponent navigate={navigate} id={params.id} name={params.name}
      ></CreateCampaignComponent>
    </div>
  );
}
export default CreateCampaign;
